import { motion } from "framer-motion";
import { AlertTriangle, X } from "lucide-react";
import { MODAL_OVERLAY, SCALE_IN } from "../lib/animations";

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, staffName }) => {
  if (!isOpen) return null;

  return (
    <motion.div
      {...MODAL_OVERLAY}
      className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="delete-modal-overlay"
    >
      <motion.div
        {...SCALE_IN}
        className="glass-overlay p-6 w-full max-w-sm relative"
        onClick={(e) => e.stopPropagation()}
        data-testid="delete-modal"
      >
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#FF3366]/50 to-transparent" />
        <div className="text-center">
          <div className="mx-auto w-12 h-12 border border-[#FF3366]/40 bg-[#FF3366]/10 flex items-center justify-center mb-4">
            <AlertTriangle className="w-5 h-5 text-[#FF3366]" />
          </div>
          <h3 className="font-mono text-sm font-bold text-zinc-200 uppercase tracking-wider mb-2">
            Delete Staff Member
          </h3>
          <p className="text-zinc-400 text-xs mb-6">
            Remove <span className="text-zinc-200 font-medium">{staffName}</span>? This cannot be undone.
          </p>
          <div className="flex gap-2 justify-center">
            <button onClick={onClose} className="btn-secondary" data-testid="cancel-delete-btn">
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="bg-[#FF3366] hover:bg-[#E6004C] text-white font-mono font-bold text-xs py-2 px-5 uppercase tracking-wider transition-colors"
              data-testid="confirm-delete-btn"
            >
              Delete
            </button>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default DeleteConfirmModal;
